import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { deletePayslipInput } from '@/api/payslipInputs'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import { useToasts } from '@/core/composables/useToasts'
import { useI18n } from 'vue-i18n'

interface Props {
  /** The ID of the payslip input to delete */
  payslipInputId: number
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'SalaryDeletionDialog'
},
  __name: 'SalaryDeletionDialog',
  props: {
    payslipInputId: {}
  },
  emits: ["deleted", "error"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit



const { t } = useI18n()
const { addSuccessToast, addDangerToast } = useToasts()

const deleteSalary = async ({
  close
}: CardDialogActionParams): Promise<void> => {
  try {
    await deletePayslipInput(props.payslipInputId)
    addSuccessToast({ content: t('salary.success.delete') })
    emit('deleted')
  } catch (error) {
    addDangerToast({ content: t('salary.errors.delete') })
    console.error(error)
    emit('error')
  } finally {
    close()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ConfirmDialog, {
    title: _unref(t)('salary.actions.delete'),
    onAction: deleteSalary
  }, {
    action: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('general.delete')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(t)('salary.confirm.delete_draft')), 1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})